import { fns } from '@macs-frontend/core/utils/date-fns';
import { AppDateTime, parseAppDateTime } from '@macs-frontend/core/utils/datetime';
import { F } from '@macs-frontend/core/utils/fp-ts';

export class DateUtils {
  static calculateAge(dateString: string): number {
    const birthday = new Date(dateString);
    const ms = Date.now() - birthday.getTime();
    const age = new Date(ms);

    return Math.abs(age.getUTCFullYear() - 1970);
  }

  static formatForState(date: Date): string {
    return F.pipe(date, fns.format('yyyy-MM-dd HH:mm:ss'));
  }
}

export function sortByCreatedAt(
  a: { createdAt?: AppDateTime },
  b: { createdAt?: AppDateTime },
): number {
  if (!a.createdAt || !b.createdAt) {
    return 0;
  }

  return (
    parseAppDateTime(a.createdAt).getTime() - parseAppDateTime(b.createdAt).getTime()
  );
}
